<template>
  <div class="page-header">
    <div class="header-left">
      <h2><i class="fas fa-list-ol"></i> Orthopedic Clinic Queue</h2>
    </div>
  </div>
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <!-- Table Heading -->
    <template v-slot:table-heading>
      <th class="text-uppercase">#s/n</th>
      <th class="text-uppercase">Patient Name</th>
      <th class="text-uppercase ps-2">OPD/IPD</th>
      <th class="text-center text-uppercase">Visit Start Time</th>
      <th></th>
    </template>

    <!-- Table Contents -->
    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.name }}</h6>
              <p v-if="user.email != null" class="text-xs text-secondary mb-0">
                {{ user.email ?? "--" }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd ?? "--" }}
          </p>
          <p v-if="user.ipd != null" class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd ?? "--" }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge class="soft-badge">{{
            formatDateTime_int(user.visit_datetime)
          }}</soft-badge>
        </td>
        <td class="align-middle">
          <a
            :href="'/orthopedic_clinic/orthopedic-assessment/' + user.id"
            class="service-link"
            data-toggle="tooltip"
            data-original-title="Edit user"
            >Service</a
          >
        </td>
      </tr>
    </template>
  </BaseLayout>
</template>

<script>
import formatDateTime from "../../../timezone/utc_local_time";
import BaseLayout from "../../Patients/components/table_page_layout.vue";

export default {
  name: "PatientsIndex",
  components: {
    BaseLayout,
  },
  data() {
    return {
      users: [],
      placeHolderText: "Search name, phone, email, OPD/IPD",
      searchUrl: "get_all_clinic_search/15",
      mainUrl: "get_all_clinic_queue/15",
    };
  },
  methods: {
    handle_external_mount(payload) {
      this.users = payload;
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },
};
</script>

<style scoped>
/* Table Container */
.table-container {
  background: #d68f8f; /* soft light gray */
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

/* Table Styling */
.table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}

.table th {
  background-color: #8fd5d6; /* muted blue-gray */
  color: #ffffff;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #ddd;
  padding: 12px;
}

.table td {
  padding: 10px 8px;
  font-size: 0.85rem;
  color: #333;
  word-wrap: break-word;
}

/* Alternate row color & hover effect */
.table tbody tr {
  background-color: #ffffff;
  border-bottom: 1px solid #eee;
}

.table tbody tr:hover {
  background-color: #f1f3f5; /* subtle hover */
  cursor: pointer;
}

/* Badge */
.soft-badge {
  background-color: #3319b9;
  color: white;
  font-weight: bold;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 4px;
}

/* Service Link */
.service-link {
  border: 1px solid #607d8b;
  padding: 4px 8px;
  color: #607d8b;
  font-weight: bold;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}

.service-link:hover {
  background-color: #607d8b;
  color: white;
}

.page-header {
  background: white;
  border-radius: 10px;
  padding: 5px;
  margin-left: 2.5%;
  margin-right: 2.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
